module.exports = __webpack_public_path__ + "img/filler_3.3a1d465e.svg";